(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('ResourceTypeDeleteController',ResourceTypeDeleteController);

    ResourceTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'ResourceType'];

    function ResourceTypeDeleteController($uibModalInstance, entity, ResourceType) {
        var vm = this;

        vm.resourceType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ResourceType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
